module.exports = __webpack_public_path__ + "static/media/comment-instagram.13286fea.svg";